// extracted by mini-css-extract-plugin
export default {"container":"dO-z","modal":"eO-z","dimensions":"fO-z","brandName":"gO-z","productName":"hO-z","recipientEmail":"iO-z","recommendedFit":"jO-z","hiddenField":"kO-z"};